import React from 'react';

import ArticleShow from '../articles/ArticleShow';

const NewsShow = props => (
	<ArticleShow {...props} />
);

export default NewsShow;
